import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArkUnitOfWork } from 'app/core/core.module';
import { DevExtremeModule } from 'devextreme-angular';
import { DxContextMenuComponent } from 'devextreme-angular/ui/context-menu';
import { DxSchedulerComponent } from 'devextreme-angular/ui/scheduler';
import moment from 'moment';
const appointmentClassName = '.dx-scheduler-appointment';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    imports: [CommonModule, DevExtremeModule],
    standalone: true,
})
export class CalendarComponent implements OnInit {
    anniversaries: any[];
    birthdays: any[];
    employees: any;
    currentDate = new Date();
    employee: any;
    timeCategories: any;
    schedulerData: any;
    selectedDate = new Date();
    showAsDialog = false;
    processing = true;
    currentViewStart: any;
    specialAccounts: any[];
    target: string = appointmentClassName;
    gray: string = '#C0C0C0';
    blue: string = '#1c84c6';
    red: string = '#FF0000';
    green: string = '#27a400';

    @ViewChild('scheduler') scheduler: DxSchedulerComponent;
    @ViewChild('appointmentMenu') appointmentMenu: DxContextMenuComponent;
    @ViewChild('cellMenu') cellMenu: DxContextMenuComponent;

    appointmentContextMenuItems = [
        // { text: "Add New", onItemClick: (e) => this.addFlockSchedule(e) },
        { text: 'Go to Today', onItemClick: () => this.showCurrentDate() },
    ];

    cellContextMenuItems = [{ text: 'Go to Today', onItemClick: () => this.showCurrentDate() }];

    contextMenuCellData: any;
    appointmentData: any;

    constructor(private uow: ArkUnitOfWork) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.specialAccounts = await this.uow.getAccounts();
        let scheduleData = [];
        const birthdays = (await this.uow.getBirthdays()) as any;
        birthdays.forEach((birthday) => {
            const yearOffset = new Date().getFullYear() - moment(birthday.date).year();
            // console.log(yearOffset);
            birthday.yearDate = moment(birthday.date).add(yearOffset, 'years').toDate();
            birthday.type = 'birthday';
            scheduleData.push(birthday);
            // console.log(birthday);
        });

        const anniversaries = (await this.uow.getAnniversaries()) as any;
        anniversaries.forEach((anniversary) => {
            if (anniversary.date !== null) {
                const yearOffset = new Date().getFullYear() - moment(anniversary.date).year();
                anniversary.yearDate = moment(anniversary.date).add(yearOffset, 'years').toDate();
                anniversary.type = 'anniversary';
                scheduleData.push(anniversary);
            }
        });

        this.schedulerData = scheduleData
            .filter((x) => {
                return !x.deleted;
            })
            .map((x: any) => {
                return {
                    name: x.name,
                    startDate: x.yearDate,
                    color: x.type === 'birthday' ? this.green : this.blue,
                };
            });
    }

    setBackGroundColor(e) {
        e.appointmentElement.style.backgroundColor = e.appointmentData.color;
    }
    toolTip(e) {
        e.cancel = true;
    }

    onCellContextMenu(e) {
        this.contextMenuCellData = e.cellData;
    }
    onAppointmentContextMenu = (e) => {
        this.appointmentData = e.appointmentData;
    };

    onContentReady(e) {
        this.currentViewStart = moment(e.component.getStartViewDate()).format('M/DD/YYYY');
    }

    showCurrentDate() {
        this.currentDate = new Date();
    }

    onContextMenuItemClick = (e) => {
        e.itemData.onItemClick(e);
    };
    onAppointmentMenuItemClick = (e) => {
        // e.itemData.onItemClick = (e) => {return e};
    };
}
